export const Asterisk = ({ ariaHidden }: { ariaHidden?: boolean }) => {
  return (
    <span aria-hidden={ariaHidden} className="pl-[2px] text-red-500">
      *
    </span>
  )
}
